import script from "./ToggleCameraButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToggleCameraButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__